import React, { useState } from "react";
import cx from "classnames";
import { Flex } from "@theorgchartdev/storybook";
import * as StateLib from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";
import { useChartDocumentContext } from "@/providers/ChartDocumentProvider";
import { isAgentProfileEnabled } from "@/appComponents/Blocks/Cards/ProfileBaseballCard/Agent/AgentProfile.constants";

// Self-gating so the chart toolbar and the phone toolbar can host it interchangeably.
const AgentViewToggle = () => {
  // Seeded from wsMgr: the phone bar unmounts this while search is open, and the overlay outlives it.
  const [isActive, setIsActive] = useState(
    () => StateLib.GetWSMgr()?.GetAgentViewActive() ?? false
  );
  const { chartDocument } = useChartDocumentContext();
  const disabled = chartDocument.state === null;

  const doc = StateLib.GetDoc();
  if (!isAgentProfileEnabled() || !doc?.HasAgentField()) return null;

  const onToggle = () => {
    if (disabled) return;
    const wsMgr = StateLib.GetWSMgr();
    const next = !(wsMgr?.GetAgentViewActive() ?? isActive);
    setIsActive(next);
    wsMgr?.SetAgentViewActive(next);
    wsMgr?.ApplyChartHighlights();
    wsMgr?.SignalDocChanged();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onToggle();
    }
  };

  return (
    <Flex
      alignItems={"center"}
      gap={"4px"}
      className={cx("oc-agent-view-toggle", {
        "oc-agent-view-toggle--active": isActive,
        "oc-agent-view-toggle--disabled": disabled
      })}
      dataTestId={"agent-view-toggle"}
      divProps={{
        onClick: onToggle,
        onKeyDown: handleKeyDown,
        role: "button",
        tabIndex: disabled ? -1 : 0,
        "aria-pressed": isActive,
        "aria-disabled": disabled
      }}
    >
      {/* Not localized: translated states overflow the pill; ON/OFF is universal. */}
      <span className="oc-agent-view-toggle-state">{isActive ? "ON" : "OFF"}</span>
      <span className="oc-agent-view-toggle-label">{appstr("Agent View")}</span>
    </Flex>
  );
};

export default AgentViewToggle;
